@if(reOrder){
<div cdkDropList cdkScrollable [cdkDropListData]="categories?.categories" cdkDropListOrientation="vertical"
    (cdkDropListDropped)="drop($event, categories?.categories)" class="row" [cdkDropListAutoScrollStep]="10">
    <nz-collapse nzGhost nzAccordion="true" class="no-rotate-accordion px-0">
        <ng-container *ngFor="let child of categories.categories; let i=index; trackBy: trackByCategoryId">
            @if(child['lastcat'] == 0){
            <nz-collapse-panel cdkDrag [cdkDragDisabled]="child['isOpen']" [nzHeader]="customHeader"
                [nzShowArrow]="false" [nzActive]="child['isOpen']" (cdkDragMoved)="onDragMove($event)"
                (nzActiveChange)="onPanelClose($event, child, categories?.categories, i)"
                [ngClass]="{ 'collapse-hover': child.hovered && !child['isOpen']}"
                [class.select-header]="child['seqno'] == apiService.activeSelection.selectedSeqId"
                (mouseenter)="$event.stopPropagation(); handleHover(child, categories?.categories, true)"
                (click)="$event.stopPropagation();"
                (mouseleave)="$event.stopPropagation(); removeHover(child, categories?.categories, true)">

                <ng-template #customHeader>
                    <div class="d-flex justify-content-between px-2" (click)="loadChildCategory(child)"
                        [ngClass]="{'highlight-header' : child['isOpen'] }">
                        <div>
                            <i class="holder-icon" nz-icon nzType='holder' cdkDragHandle
                                [ngClass]="{'highlight-header' : child['isOpen'] }"></i>
                            <span class="ml-10">{{ child['categoryname'] | decodeSpecialChar }}</span>
                        </div>
                        @if(child['hideonweb'] == 1){
                        <!-- <i class="fs-20" nz-icon nzType='eye-invisible' nz-tooltip="Product hidden on website"></i> -->
                        <img nz-tooltip="Product hidden on website" class="mr-10" [src]="'eye-invisible.svg'"
                            width="22px" height="22px" />
                        }
                    </div>
                </ng-template>
                <ng-template #holderIcon>
                    <i class="holder-icon" nz-icon nzType='holder' cdkDragHandle
                        [ngClass]="{'highlight-header' : child['isOpen'] }"></i>
                </ng-template>
                @defer (when child['isOpen']) {
                <ng-container *ngIf="child?.categories?.length > 0 && child['lastcat'] === 0 && child['renderChild']">
                    <app-category-accordion-child [reOrder]="reOrder" [categories]="child"
                        (emitSeqId)="loadChildCategory($event)"></app-category-accordion-child>
                </ng-container>
                } @placeholder {
                <div *ngIf="child.categories?.length > 20 && child['lastcat'] === 0" class="p-3 text-center">
                    <span class="fst-italic">Loading ...</span>
                </div>
                }

            </nz-collapse-panel>
            } @else {
            <nz-collapse-panel cdkDrag [cdkDragDisabled]="child['isOpen']" class="px-0 mb-2 product-collapse"
                [nzHeader]="customHeader" [ngClass]="{ 'collapse-hover': child.hovered && !child['isOpen']}"
                [class.select-content]="child['seqno'] == apiService.activeSelection.selectedSeqId"
                [nzShowArrow]="false" [nzActive]="true" style="cursor: pointer; width:98%; position: relative;"
                [nzDisabled]="true" (cdkDragMoved)="onDragMove($event)" (click)="$event.stopPropagation()"
                (mouseenter)="$event.stopPropagation(); handleHover(child, categories?.category, true)"
                (mouseleave)="$event.stopPropagation(); handleHover(child, categories?.category, false)">

                <ng-template #customHeader>
                    <div class="d-flex py-0 custom-header justify-content-between" (click)="$event.stopPropagation();"
                        style="cursor: initial;">
                        <div class="d-flex flex-column" (click)="$event.stopPropagation();">
                            <div class="d-flex float-icon" (click)="$event.stopPropagation(); loadChildCategory(child)">
                                <i class="holder-icon" nz-icon nzType='holder'
                                    [ngClass]="{'highlight-header' : child['isOpen'] }"
                                    [class.select-header]="child['seqno'] == apiService.activeSelection.selectedSeqId"></i>
                                <span class="ml-10">{{ child['categoryname'] | decodeSpecialChar }}</span>
                                @if(child['hideonweb'] == 1){
                                <!-- <i class="fs-20" nz-icon nzType='eye-invisible'
                                    nz-tooltip="Product hidden on website"></i> -->
                                <img nz-tooltip="Product hidden on website" class="mr-10 ml-10"
                                    [src]="'eye-invisible.svg'" width="22px" height="22px" />
                                }
                            </div>
                        </div>
                    </div>
                </ng-template>

                <div class="style-content d-flex flex-wrap">
                    <ng-container *ngFor="let tag of child['lots'] | slice: 0:3">
                        <nz-tag style="cursor: initial;" [style.opacity]="$any(tag).hideOnWeb == 1 ? '0.5' : '1'"
                            [style.filter]="$any(tag).hideOnWeb == 1 ? 'grayscale(1)' : 'none'"
                            (click)="$event.stopPropagation()" class="m-1">
                            {{ ($any(tag))?.lotId }}
                        </nz-tag>
                    </ng-container>
                    <nz-tag style="cursor: initial;" (click)="$event.stopPropagation()" class="m-1"
                        *ngIf="child['lots'] && child['lots'].length > 3">
                        {{ child['lots'].length - 3 }} more
                    </nz-tag>
                </div>

                <!-- OPTIMIZED LAZY LAYER FOR PRODUCT INNER ELEMENTS -->
                @defer (when child['isOpen']) {
                <ng-container *ngIf="child?.category?.length > 0 && child['lastcat'] === 0 && child['renderChild']">
                    <app-category-accordion-child [reOrder]="reOrder"
                        [categories]="child"></app-category-accordion-child>
                </ng-container>
                }

            </nz-collapse-panel>
            }
        </ng-container>
    </nz-collapse>
</div>
}

@if(!reOrder){
<div class="row">
    <nz-collapse nzGhost nzAccordion="true" class="no-rotate-accordion px-0">
        <ng-container *ngFor="let child of categories.categories; let i=index; trackBy: trackByCategoryId">
            @if(child['lastcat'] == 0){
            <nz-collapse-panel [nzHeader]="customHeader" [nzExtra]="customExpandIcon" [nzShowArrow]="false"
                [nzActive]="child['isOpen']" [ngClass]="{ 'collapse-hover': child.hovered && !child['isOpen']}"
                [class.select-header]="child['seqno'] == apiService.activeSelection.selectedSeqId"
                (click)="$event.stopPropagation();"
                (nzActiveChange)="onPanelClose($event, child, categories?.categories, i)"
                (mouseenter)="$event.stopPropagation(); handleHover(child, categories?.categories, true)"
                (mouseleave)="$event.stopPropagation(); removeHover(child, categories?.categories, true)">

                <ng-template #customHeader>
                    <div class="d-flex justify-content-between px-2" (click)="loadChildCategory(child)"
                        [ngClass]="{'highlight-header' : child['isOpen'] }">
                        <div>
                            <i class="skin-icon" nz-icon nzType='skin'
                                [ngClass]="{'highlight-header' : child['isOpen'] }"></i>
                            <span class="ml-10">{{ child['categoryname'] | decodeSpecialChar }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            @if(child['hideonweb'] == 1){
                            <!-- <i class="fs-20 mr-15" nz-icon nzType='eye-invisible'
                                nz-tooltip="Product hidden on website"></i> -->
                            <img nz-tooltip="Product hidden on website" class="mr-10" [src]="'eye-invisible.svg'"
                                width="22px" height="22px" />
                            }
                            <span class="dropdownIcon p-1" nz-dropdown [nzDropdownMenu]="menu"
                                (click)="$event.stopPropagation(); child['isMenuOpen']=true;" nzTrigger="click"
                                [nzVisible]="child['isMenuOpen']" nz-icon nzType="ellipsis"></span>
                            <nz-dropdown-menu #menu="nzDropdownMenu">
                                <ul nz-menu class="category-options px-1" (mouseleave)="onMenuLeave(child)">
                                    <li (click)="duplicateCategory(child)" nz-menu-item>
                                        <i class="dropdown-icon px-1" nz-icon [nzType]="'copy'"></i>Duplicate
                                    </li>
                                    <li (click)="deleteCategory(child)" nz-menu-item>
                                        <i class="dropdown-icon px-1" nz-icon [nzType]="'delete'"></i>Delete
                                    </li>
                                </ul>
                            </nz-dropdown-menu>
                        </div>
                    </div>
                </ng-template>
                <ng-template #customExpandIcon>
                    <i (click)="$event.stopPropagation(); onPanelClose(child['isOpen'] ? false : true, child, categories?.categories, i)"
                        class="expand-icon" nz-icon [nzType]="child['isOpen'] ? 'up' : 'down'"></i>
                </ng-template>
                <ng-template #skinIcon>
                    <i class="skin-icon" nz-icon nzType='skin' [ngClass]="{'highlight-header' : child['isOpen'] }"></i>
                </ng-template>

                <div *ngIf="child['isOpen'] && !child['renderChild'] && child.categories?.length > 20 && child['lastcat'] === 0"
                    class="p-3 text-center">
                    <span class="fst-italic">Loading ...</span>
                </div>

                <ng-container *ngIf="child?.categories?.length > 0 && child['lastcat'] === 0 && child['renderChild']">
                    <app-category-accordion-child [categories]="child" [catalogId]="catalogId"
                        (emitSeqId)="loadChildCategory($event)"></app-category-accordion-child>
                </ng-container>

            </nz-collapse-panel>
            } @else if(child['lastcat'] == 1){
            <nz-collapse-panel class="px-0 mb-2 product-collapse" [nzHeader]="customHeader"
                [ngClass]="{ 'collapse-hover': child.hovered && !child['isOpen']}"
                [class.select-content]="child['seqno'] == apiService.activeSelection.selectedSeqId"
                [nzShowArrow]="false" [nzActive]="true" style="cursor:pointer; width:98%; position: relative;"
                [nzDisabled]="true" (click)="$event.stopPropagation(); loadChildCategory(child)"
                (mouseenter)="$event.stopPropagation(); handleHover(child, categories?.category, true)"
                (mouseleave)="$event.stopPropagation(); handleHover(child, categories?.category, false)">

                <ng-template #customHeader>
                    <div class="d-flex py-0 custom-header justify-content-between">
                        <div class="d-flex flex-column w-100">
                            <div class="d-flex float-icon row">
                                <div class="col-md-10">
                                    <div class="d-flex">
                                        <i class="skin-icon" nz-icon nzType='skin'
                                            [ngClass]="{'highlight-header' : child['isOpen'] }"
                                            [class.select-header]="child['seqno'] == apiService.activeSelection.selectedSeqId"></i>
                                        <span class="ml-10">{{ child['categoryname'] | decodeSpecialChar }} </span>
                                    </div>
                                </div>
                                <div class="col-md-2 d-flex justify-content-end">
                                    @if(child['hideonweb'] == 1){
                                    <!-- <i class="fs-20 mr-15" nz-icon nzType='eye-invisible'
                                        nz-tooltip="Product hidden on website"></i> -->
                                    <img nz-tooltip="Product hidden on website" class="mr-10 mt-10"
                                        [src]="'eye-invisible.svg'" width="22px" height="22px" />
                                    }
                                    <span class="dropdownIcon py-1 ml-5 mt-0" nz-dropdown [nzDropdownMenu]="menu"
                                        (click)="$event.stopPropagation(); child['isMenuOpen']=true;" nzTrigger="click"
                                        [nzVisible]="child['isMenuOpen']" nz-icon nzType="ellipsis"></span>
                                </div>
                            </div>
                            <nz-dropdown-menu #menu="nzDropdownMenu">
                                <ul nz-menu class="category-options px-1" (mouseleave)="onMenuLeave(child)">
                                    <li (click)="preview(child)" nz-menu-item>
                                        <img class="dropdown-icon px-0" [src]="'eye-visible.svg'"  />
                                        <!-- <i  nz-icon [nzType]="'eye'"> -->

                                        <!-- </i> -->
                                        Preview
                                    </li>
                                    <li (click)="duplicateCategory(child, true)" nz-menu-item>
                                        <!-- <i class="dropdown-icon px-1" nz-icon nzType="copy"></i> -->
                                         <img class="dropdown-icon px-0" [src]="'copy.svg'"  />
                                        Duplicate
                                    </li>
                                    <li (click)="deleteCategory(child, true)" nz-menu-item>
                                        <!-- <i class="dropdown-icon px-1" nz-icon [nzType]="'delete'"></i> -->
                                         <img class="dropdown-icon px-0" [src]="'delete.svg'"  />
                                        Delete
                                    </li>
                                </ul>
                            </nz-dropdown-menu>

                        </div>
                    </div>
                </ng-template>

                <div style="cursor: initial;" class="style-content d-flex flex-wrap" (click)="$event.stopPropagation()">
                    <ng-container *ngFor="let tag of child['lots'] | slice: 0:3">
                        <nz-tag style="cursor: initial;" [style.opacity]="$any(tag).hideOnWeb == 1 ? '0.5' : '1'"
                            [style.filter]="$any(tag).hideOnWeb == 1 ? 'grayscale(1)' : 'none'"
                            (click)="$event.stopPropagation()" class="m-1">
                            {{ ($any(tag))?.lotId }}
                        </nz-tag>
                    </ng-container>
                    <nz-tag style="cursor: initial;" (click)="$event.stopPropagation()" class="m-1"
                        *ngIf="child['lots'] && child['lots'].length > 3">
                        {{ child['lots'].length - 3 }} more
                    </nz-tag>
                </div>
                <div *ngIf="child['isOpen'] && !child['renderChild'] && child.categories?.length > 20 && child['lastcat'] === 0"
                    class="p-3 text-center">
                    <span class="fst-italic">Loading ...</span>
                </div>

                <ng-container *ngIf="child?.category?.length > 0 && child['lastcat'] === 0 && child['renderChild']">
                    <app-category-accordion-child [catalogId]="catalogId"
                        [categories]="child"></app-category-accordion-child>
                </ng-container>

            </nz-collapse-panel>
            }
            <nz-modal *ngIf="child.isPreviewOpen" (nzOnOk)="child.isPreviewOpen = false" [nzFooter]="modalFooter"
                (nzOnCancel)="child.isPreviewOpen = false" nzClosable nzCentered [nzWidth]="900"
                [(nzVisible)]="child.isPreviewOpen" [nzBodyStyle]="{ height: '550px', overflowY: 'hidden' }"
                [nzTitle]="child['short-desc']">
                <ng-container *nzModalContent>
                    <app-catalog-preview [previewData]="previewDetails"
                        [imageLoading]="imageLoading"></app-catalog-preview>
                </ng-container>
                <ng-template #modalFooter>
                    <button nz-button (click)="child.isPreviewOpen = false" nzType="primary">OK</button>
                </ng-template>
            </nz-modal>
        </ng-container>
    </nz-collapse>
</div>
}

<app-confirm-popup *ngIf="showModal" [title]="modalButton" [message]="modalMessage" [confirmText]="modalButton"
    [cancelText]="'Cancel'" [triggerModal]="showModal" (confirm)="onConfirm()"
    (cancel)="showModal = false"></app-confirm-popup>